import { PublicKey, Transaction, TransactionInstruction } from '@solana/web3.js';
import { API_BASE } from './api';

export const MEMO_PROGRAM_ID = 'MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr';

export const fetchLatestBlockhash = async ({ fetchImpl = fetch } = {}) => {
    const response = await fetchImpl(`${API_BASE}blockhash`);
    if (!response.ok) {
        throw new Error('Unable to fetch a recent blockhash');
    }
    const data = await response.json();
    if (!data?.blockhash) {
        throw new Error('Unable to fetch a recent blockhash');
    }
    return data;
};

export const signMigrationMemo = async ({
    signTransaction,
    publicKey,
    message,
    fetchImpl = fetch
}) => {
    if (!signTransaction || !publicKey) {
        throw new Error('This wallet cannot sign the migration request');
    }

    const tx = new Transaction().add(new TransactionInstruction({
        keys: [{ pubkey: publicKey, isSigner: true, isWritable: false }],
        programId: new PublicKey(MEMO_PROGRAM_ID),
        data: Buffer.from(message, 'utf8')
    }));
    tx.feePayer = publicKey;
    const { blockhash } = await fetchLatestBlockhash({ fetchImpl });
    tx.recentBlockhash = blockhash;
    const signed = await signTransaction(tx);
    const bytes = signed.serialize({ requireAllSignatures: true, verifySignatures: true });
    let binary = '';
    bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
    });
    return btoa(binary);
};
